import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@primer/react';
import { workProjects, workOrder } from '../data/workProjects';

const pillSx = {
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  paddingX: 4,
  paddingY: 2,
  borderRadius: '999px',
  border: '1px solid rgba(255, 255, 255, 0.16)',
  backgroundColor: 'rgba(255, 255, 255, 0.08)',
  color: 'rgba(255, 255, 255, 0.85)',
  fontSize: 1,
  fontWeight: 500,
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  transition: 'background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease',
  ':hover': {
    backgroundColor: '#f5f1ea',
    borderColor: '#f5f1ea',
    color: '#05070a',
  },
};

function WorkNav() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        paddingX: 3,
        paddingY: 2,
        borderRadius: '999px',
        border: '1px solid rgba(255, 255, 255, 0.18)',
        backgroundColor: 'rgba(13, 17, 23, 0.55)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.35)',
        maxWidth: ['calc(100vw - 48px)', '560px', '860px'],
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': { display: 'none' },
      }}
    >
      {workOrder.map((slug) => (
        <Box as={RouterLink} key={slug} to={`/work/${slug}`} sx={pillSx}>
          {workProjects[slug].navLabel}
        </Box>
      ))}
    </Box>
  );
}

export default WorkNav;
